import { gql, type TypedDocumentNode } from "@apollo/client";
import { type GQL } from "@binale-tech/shared";

export const userToggle2fa: TypedDocumentNode<
    Pick<GQL.IMutation, "userToggle2fa">,
    GQL.IMutationUserToggle2faArgs
> = gql`
    mutation userToggle2fa($input: UserToggle2faInput!) {
        userToggle2fa(input: $input)
    }
`;
